
interface Holiday {

    id: string;
    name: string;
    description: string;
    observingStartDate: string;
    observingEndDate: string;
    officialDate: string;
}

export const mapToHolidays = (supabaseHolidays : any[]) : Holiday[] =>  {
    
    const result : Holiday[] = supabaseHolidays.map(sh => ({
        id: sh.id,
        name: sh.name,
        description: sh.description,
        observingStartDate: sh.observing_start_date,
        observingEndDate: sh.observing_end_date,
        officialDate: sh.official_date,
    }));

    return result;
}

export const DEFAULT_HOLIDAY : Holiday = {
    id: '',
    name: '',
    description: '',
    observingStartDate: '',
    observingEndDate: '',
    officialDate: '',
};

export default Holiday;